var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center flex-column greyborder"},[_c('div',{staticClass:"text-h4 font-weight-black grey--text"},[_vm._v(_vm._s(_vm.day))]),_c('div',{staticClass:"text-h7 font-weight-bold grey--text text--darken-1 text-uppercase"},[_vm._v(_vm._s(_vm.month))])])
}
var staticRenderFns = []

export { render, staticRenderFns }